var heading_default = {
  "fontElementMap": "lEqCi",
  "elementSpacing": "RDl0h",
  "headerOne": "pbHbm RDl0h",
  "headerTwo": "lXZRU RDl0h",
  "headerThree": "U4scq RDl0h",
  "headerFour": "tXXNA RDl0h",
  "headerFive": "GfbaW RDl0h",
  "headerSix": "Nqf21 RDl0h",
  "child": "r7uxn"
};
export {
  heading_default as default
};
//# sourceMappingURL=heading-scss.js.map
